import React from "react";

function AlertMessage(props) {
  return (
    <>
      <article
        className={
          "rtds-card rtds-card--information rtds-card--information-left-icon rtds-card--horizontal rtds-card--horizontal-left rtds-group/card " +
          (props.classArticle ?? "")
        }
      >
        <div className={"rtds-card__icon " + (props.classDiv ?? "")}>
          <svg
            className="rtds-icon rtds-fill-current rtds-w-12 rtds-h-12"
            aria-hidden="true"
            focusable="false"
            role="img"
          >
            <use
              xlinkHref={`${process.env.PUBLIC_URL}/icons.svg#${props.iconName}`}
            />
          </svg>
        </div>

        <div className="rtds-card__content">
          {props.title && <div className="rtds-card__heading">
            <h3 className="rtds-card__title">
              <span className="rtds-heading-3">{props.title}</span>
            </h3>
          </div>}
          <div className="rtds-card__description ">
            <div className="">
              <span className="rtds-body">{props.message}</span>
            </div>
          </div>
        </div>
      </article>
    </>
  );
}

export default AlertMessage;
